import { createFileRoute } from "@tanstack/react-router";
import { EventsTable } from "#/components/events/EventsTable";
import { Card, PageHeading } from "@/ui";

export const Route = createFileRoute(
  "/dashboard/w/$workspaceId/sending/events",
)({
  component: EventLogsPage,
});

// Same single-card shape as its two siblings (templates and bounces), which is
// why the heading carries no card title of its own. The Refresh control that
// used to sit in `PageHeading`'s action slot was removed as product feedback —
// `EventsTable` polls on a 30s interval and refetches on window focus instead.
// Both come from `listFetchPolicy` and both switch off past
// `MAX_AUTO_REFETCH_PAGES`; that depth carries its own notice and a manual
// refresh, so the removal above is not what leaves a deep log still.
function EventLogsPage() {
  const { workspaceId } = Route.useParams();

  return (
    <div className="flex flex-col gap-6">
      <PageHeading title="Event logs" />
      <Card>
        <div className="flex flex-col gap-2">
          <EventsTable workspaceId={workspaceId} />
          <p className="text-xs" style={{ color: "var(--gs-muted)" }}>
            Delivery events for the transactional API. This is a log of messages, not of people.
          </p>
        </div>
      </Card>
    </div>
  );
}
